import React, { useRef, useState, useEffect } from 'react';
import { map } from 'lodash/fp';
import { useWindowSize } from '../../../../utils';
import { TableCard } from '../../../../ui-kit';
import { GRID_COLUMNS, GRID_ROWS } from './constants';
import { EditTableForm } from './forms/update';
import { KeyedSections, TableMapViewProps } from './types';
import { GridLayout, GridLayoutWraper } from './style';

const TableMapView = ({ mappedPlaces, onDragStop, sectionId }: TableMapViewProps) => {
    const windowSize = useWindowSize();
    const ref = useRef<HTMLDivElement | null>(null);
    const [activePlaceId, setActivePlaceId] = useState<keyof KeyedSections | null>(null);
    const [layoutWidth, setLayoutWidth] = useState<number>(0);
    const [rowHeight, setRowHeight] = useState<number>(0);
    const closeCurrentPlaceForm = () => setActivePlaceId(null);

    useEffect(() => {
        if (ref.current) {
            const clientHeight = document ? document.body.clientHeight : ref.current.offsetWidth;
            const height = clientHeight - ref.current.offsetTop;
            const calculatedRowHeight = Math.floor(Math.round(height / 2) * 2 / GRID_ROWS);
            setRowHeight(calculatedRowHeight);
            setLayoutWidth(calculatedRowHeight * GRID_COLUMNS);
        }
    }, [ref, windowSize]);

    return (
        <>
            {/* @ts-ignore */}
            <GridLayoutWraper ref={ref}>
                <GridLayout
                    height={rowHeight * GRID_ROWS}
                    preventCollision
                    isDroppable
                    onDragStop={onDragStop}
                    maxRows={GRID_ROWS}
                    autoSize={false}
                    backgroundSize={rowHeight}
                    compactType={null}
                    layout={mappedPlaces}
                    cols={GRID_COLUMNS}
                    width={layoutWidth}
                    rowHeight={rowHeight}
                    margin={[0, 0]}
                >
                    {map(({ i, name, isToGo }) => (
                        <TableCard
                            onClick={() => setActivePlaceId(i)}
                            isActive={activePlaceId === i}
                            key={i}
                            id={i}
                            name={name}
                            onClose={closeCurrentPlaceForm}
                        >
                            <EditTableForm
                                onClose={closeCurrentPlaceForm}
                                tableId={i}
                                isToGo={isToGo}
                                tableName={name}
                                sectionId={sectionId}
                            />
                        </TableCard>
                ), mappedPlaces)}
                </GridLayout>
            </GridLayoutWraper>
        </>
    );
};

export default TableMapView;
